import React from 'react'
import {ourProducts2 as ourProducts} from '../data/ourProducts2.js'
import {useParams} from 'react-router-dom'

import * as Products from '../data/products/ProductsProvider'

import {HashLink} from 'react-router-hash-link'

import clientsInfo from '../data/clients.json'

import {Link} from 'react-router-dom'

import './styles/Clients.scss'
import './styles/Product.scss'

import MainForm from './MainForm'

function Product() {
    const {idOfProduct} = useParams()
    // console.log(ourProducts)

    let foundProduct = null
    let ProductInfo = null

    const arrayOfClients = []

    for (let category of ourProducts) {
        // Поиск в массиве products внутри каждого объекта
        // console.log(idOfProduct)
        foundProduct = category.products.find((item) => item.id === Number(idOfProduct))

        // console.log(category.products, idOfProduct)

        // Если найден, прерываем цикл
        if (foundProduct) {
            if (Products[`ID${foundProduct.id}`]) {
                ProductInfo = Products[`ID${foundProduct.id}`]
            }

            for (let client of clientsInfo) {
                // Проверяем, содержит ли клиент найденный продукт в списке приобретенных продуктов
                if (client.products && client.products.includes(foundProduct.id)) {
                    // Если да, добавляем клиента в массив arrayOfClients
                    arrayOfClients.push(client)
                }
            }

            // console.log(arrayOfClients)
            break
        }
    }

    return (
        <div>
            <div className="product-container">
                {/* <MainForm />
            <br /> */}

                <HashLink className={({isActive}) => (isActive ? 'activeLink' : 'link')} to="/#our-products">
                    Назад к списку
                </HashLink>
                <br/>
                <br/>

                {ourProducts.length > 0 ? (
                    foundProduct ? (
                        <div>
                            <div>
                                <h2>{foundProduct.productName}</h2>
                                <p>{foundProduct.description}</p>
                                {/* Другие свойства найденного продукта */}

                                {ProductInfo != null ? <ProductInfo/> : 'Данные пока отсутствуют...'}
                            </div>
                            <br/>
                            <br/>
                            <div>
                                <h3>Этой услугой воспользовались:</h3>
                                <br/>
                                <div className="clientsList">
                                    {arrayOfClients.length > 0
                                        ? arrayOfClients.map((el, index) => {
                                            return (
                                                <Link key={index} className="clientsList__item"
                                                      to={`/clients/${el.name}`}>
                                                    {/* {el.name} */}
                                                    <div
                                                        className="clientsList-logo"
                                                        style={{backgroundImage: `url(${require(`../images/client-logos/${el.name}.png`)})`}}
                                                    ></div>
                                                </Link>
                                            )
                                        })
                                        : 'Данные пока отсутствуют...'}
                                </div>
                            </div>
                        </div>
                    ) : (
                        <p>Продукт не найден</p>
                    )
                ) : (
                    'Loading...'
                )}

                <br/>
                <br/>

            </div>

            <MainForm/>
        </div>
    )
}

export default Product
